/**
 * @ngdoc service
 * @name billing.positions.factory:Positions
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.positions')
    .factory('Position', [
        '$translate',
        'Resource',
        Position
    ]);

function Position($translate, Resource) {
    var $model = Resource.make('billing/positions');
    $model.title = 'Position ';

    $model.schema = {
        type: 'object',
        title: $translate.instant('billing.positions.title'),
        properties: {
            id: {
                title: $translate.instant('billing.positions.labels.id'),
                type: 'number',
                listview: 'hidden',
                mergeable: false
            },
            title: {
                title: $translate.instant('billing.positions.labels.title'),
                type: 'string',
                columnDef: {
                    main: true
                }
            },
            category_id: {
                title: $translate.instant('billing.positions.labels.category_id'),
                type: 'integer',
                columnDef: {}
            },
            label: {
                title: $translate.instant('billing.positions.labels.label'),
                type: 'string',
                columnDef: {}
            },
            description: {
                title: $translate.instant('billing.positions.labels.description'),
                type: 'string',
                columnDef: {}
            },
            unit: {
                title: $translate.instant('billing.positions.labels.unit'),
                type: 'string',
                columnDef: {}
            },
            price_per_unit: {
                title: $translate.instant('billing.positions.labels.price_per_unit'),
                type: 'number',
                columnDef: {}
            }
        }
    };

    $model.form = [
        'title',
        'label',
        'description',
        'unit',
        'price_per_unit'
    ];

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/positions/factories/position-factory.js